// productMirrorUrl — the public URL of OUR OWN copy of a product photo.
//
// Phase 1 (2026-08-19) copied every comax product photo into the Supabase
// Storage bucket `product-images`, keyed by barcode: 15,060 objects, 1.76 GB,
// public-read and service-role-write-only, stamped `cacheControl 31536000`.
// This resolves a barcode to that object's public URL so ProductImg can ask our
// own CDN for the photo before falling back to the `/img` -> comax path, which
// is the third-party origin this whole arc exists to leave behind.
//
// THE KEY RULE IS SHARED WITH THE BACKFILL AND MUST NOT DRIFT.
// `scripts/mirror-product-images.mjs` writes each object as:
//     const key = `${row.barcode}.jpg`;          // line 143
// — a bare template-literal coercion of `sales_data_master.barcode`, with NO
// trimming, padding, case-folding or normalisation of any kind. This file reads
// it back exactly that way, and the script carries the matching pointer back
// here. Change one and you MUST change the other, or every lookup misses and
// the portal silently falls back to comax for every photo.
//
// The URL is built by the app's shared Supabase client, so the project ref
// comes from the same env var the rest of the app uses — never hardcoded.
// `getPublicUrl` is a pure string builder: no network, no auth, no signing, so
// calling it during render costs nothing.
import { supabase } from '../../../supabase';

export const PRODUCT_IMAGE_BUCKET = 'product-images';

export function productMirrorUrl(barcode) {
  // A product with no barcode has no mirrored object to point at. Returning
  // null (rather than a `.jpg` URL built from "undefined") is what keeps the
  // caller on its existing path instead of spending an attempt on a certain miss.
  if (barcode == null || barcode === '') return null;
  return supabase.storage
    .from(PRODUCT_IMAGE_BUCKET)
    .getPublicUrl(`${barcode}.jpg`)
    .data.publicUrl;
}
